import React, { useEffect } from "react";
import CreateUserScreen from "../screens/CreateUserScreen";
import { connect } from "react-redux";
import get from "../../utils/get";
import * as actions from "../../department/actions/register";
import * as createAction from "../actions/create";
import * as groupAction from "../../usersGroup/actions/register";
import * as screensActions  from "../../powerBi/actions/list";
import * as actionsScreens from "../../powerBi/actions/data";

const CreateUserContainer = (props) => {
  useEffect(() => {
    props.getOptions();
    props.getSubOptions();
    props.getGroupsOptions();
    props.getScreens();
    // eslint-disable-next-line
  }, []);
  return <CreateUserScreen {...props} />;
};

const mapStateToProps = (state) => ({
  isLoading: get(state, "users.create.isLoading"),
  data: get(state, "department.register.data"),
  dataSub: get(state, "department.register.dataSub"),
  optionsGroup: get(state, "groups.register.optionsGroup"),
  isLoadingOptions: get(state, "groups.register.isLoadingOptions"),
  reportsData: get(state,"test.list.reportsData"),
  isLoadingScreens: get(state, "test.list.isLoadingScreens"),
});

const mapActionsToProps = { ...actions, ...createAction, ...groupAction ,...screensActions,...actionsScreens};

export default connect(mapStateToProps, mapActionsToProps)(CreateUserContainer);
